import React, { useEffect, useState } from "react";
import API from "../../api/index";

import "react-notifications-component/dist/theme.css";
import { useNavigate, useLocation } from "react-router-dom";

const CheckLogin = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [, setLecsActive] = useState(null);

  useEffect(() => {
    const authProcessed = sessionStorage.getItem("authProcessed");
    if (authProcessed === "true") {
      setIsAuthenticated(true);
    }
    
    API.checkUser()
      .then((response) => {
        if (response.data.type === "user") {
          if (response.data.currentLecs === "Not assigned") {
            if (location.pathname !== "/user/options") {
              window.sessionStorage.setItem("selectedTab", 'Add Lecs')
              window.sessionStorage.setItem("license_expired", 'true')
              window.sessionStorage.setItem("authProcessed", 'true')
              navigate("/user/options");
            }
          } else {
            window.sessionStorage.removeItem("license_expired")
          }
          setLecsActive(response.data.currentLecs);
          setIsAuthenticated(true);
          window.sessionStorage.setItem("authProcessed", 'true')
        } 
        else if (response.data.type === "reseller") {
          setIsAuthenticated(true);
          window.sessionStorage.setItem("authProcessed", 'true')
        }
        else {
          setIsAuthenticated(false);
        }
      })
      .catch((error) => {
        sessionStorage.clear();
        setIsAuthenticated(false);
      });
  }, [location, navigate]);

  useEffect(() => {
    if(sessionStorage.getItem("type") === "user"){
      API.getTimeZone().then((response) => {
        sessionStorage.setItem("timezone", response.data)
      }).catch((error) => {
        sessionStorage.setItem("timezone", "Etc/GMT");
      })
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated === false) {
      sessionStorage.clear()
      localStorage.clear()
      navigate("/")
      
    }
  }, [isAuthenticated, navigate]);

  // Reset del flag quando l'utente fa logout
  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.removeItem("authProcessed");
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);


  if (isAuthenticated === null) {
    return <div className="container-body">Loading...</div>; // oppure un componente di caricamento
  }

  return children;
};
export default CheckLogin;
